import admin from './admin'
import context from './context'
import footer from './footer'
import locale from './locale'
import sidebar from './sidebar'
import newMenu from './new-menu'

export default {
    admin,
    context,
    footer,
    locale,
    sidebar,
    newMenu
}
